var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextPageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42907 0.62312C2.02455 0.234342 1.3716 0.237166 0.970675 0.629429C0.569748 1.02169 0.572661 1.65485 0.977182 2.04363L3.40126 4.37337C4.38507 5.31889 5.05992 5.96961 5.51656 6.52098C5.96013 7.05657 6.1123 7.4006 6.1528 7.7087C6.17823 7.90216 6.17823 8.09792 6.1528 8.29138C6.1123 8.59948 5.96013 8.94351 5.51656 9.4791C5.05992 10.0305 4.38507 10.6812 3.40127 11.6267L0.977182 13.9565C0.572661 14.3452 0.569748 14.9784 0.970675 15.3707C1.3716 15.7629 2.02455 15.7657 2.42907 15.377L4.89682 13.0052C5.82628 12.112 6.58594 11.3819 7.12467 10.7314C7.68489 10.055 8.09042 9.36841 8.19875 8.54426C8.24625 8.18289 8.24625 7.81719 8.19875 7.45582C8.09042 6.63167 7.68489 5.94509 7.12467 5.26865C6.58594 4.61816 5.82629 3.88809 4.89682 2.99483L2.42907 0.62312Z",
    fill: "#020808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPageIcon);
export default __webpack_public_path__ + "static/media/nextPageIcon.b423b429912dc97c6e0aa21935a664e8.svg";
export { ForwardRef as ReactComponent };